var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var QuestionController = /** @class */ (function () {
    function QuestionController() {
    }
    /*****************************************************************************************************
        * Is using route "api/question/export/excel/flat" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @param {string} progressId
        * @returns {LinkDto}
    ******************************************************************************************************/
    QuestionController.ExcelExportFlat = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        if (data.progressId !== undefined)
            fd.append("progressId", JSON.stringify(data.progressId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/export/excel/flat", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/question/import/excel/flat" and http method "POST" to call the back-end.
    
        * @param {ContentMediaUploadDto} importFile
        * @param {string} progressId
        * @returns {ImportResult[]}
    ******************************************************************************************************/
    QuestionController.ImportExcelFlat = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("importFile", JSON.stringify(data.importFile));
        if (data.progressId !== undefined)
            fd.append("progressId", JSON.stringify(data.progressId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/import/excel/flat", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/question/export/excel" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @param {string} progressId
        * @returns {LinkDto}
    ******************************************************************************************************/
    QuestionController.ExcelExport = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        if (data.progressId !== undefined)
            fd.append("progressId", JSON.stringify(data.progressId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/export/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/question/import/excel" and http method "POST" to call the back-end.
    
        * @param {ContentMediaUploadDto} importFile
        * @param {string} progressId
        * @returns {ImportResult[]}
    ******************************************************************************************************/
    QuestionController.ImportExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("importFile", JSON.stringify(data.importFile));
        if (data.progressId !== undefined)
            fd.append("progressId", JSON.stringify(data.progressId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/import/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/question/check/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {any} answer
        * @returns {boolean}
    ******************************************************************************************************/
    QuestionController.Check = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("answer", JSON.stringify(data.answer));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/check/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/question/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ExtendedDataCollection<QuestionDownloadDto, string>}
    ******************************************************************************************************/
    QuestionController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/question/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return QuestionController;
}());
export { QuestionController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=QuestionController.js.map